import { File, Folder } from "lucide-react";
import { formatDate } from "../../utils/helper";
import KebabMenu from "./KebabMenu";

export default function FileRow({ file, onClick, onRename, onMove, onDelete, onDownload }) {
  const isFolder = file.mimeType === "application/vnd.google-apps.folder";
  const sizeLabel = isFolder ? "—" : _formatSize(file.size);
  const modified = file.modifiedTime
    ? formatDate(file.modifiedTime)
    : "—";

  return (
    <div
      onClick={() => onClick(file)}
      className="grid grid-cols-[1fr,90px,80px,40px] gap-2 items-center px-3 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100"
    >
      <div className="flex items-center gap-2 min-w-0">
        {isFolder
          ? <Folder className="w-4 h-4 text-yellow-600 shrink-0" />
          : <File className="w-4 h-4 text-gray-500 shrink-0" />}
        <span className="truncate">{file.name}</span>
      </div>
      <span className="text-sm text-gray-600">{modified}</span>
      <span className="text-sm text-gray-600">{sizeLabel}</span>
      <KebabMenu items={[
        { label: "Rename", onClick: () => onRename(file) },
        { label: "Move", onClick: () => onMove(file) },
        ...(isFolder ? [] : [{ label: "Download", onClick: () => onDownload(file) }]),
        { label: "Delete", onClick: () => onDelete(file), danger: true },
      ]} />
    </div>
  );
}

function _formatSize(bytes) {
  if (!bytes) return "—";
  const n = Number(bytes);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
